<div class="ni-feeds">
  <div class="ni-add">
    <input type="text" placeholder="paste a blog, YouTube, or Reddit URL&hellip;"
           [(ngModel)]="urlInput" (keyup.enter)="discover()" [disabled]="busy">
    <button (click)="discover()" [disabled]="busy">
      {{ busy ? 'Looking&hellip;' : 'Find feed' }}
    </button>
  </div>
  <p class="ni-add-msg" *ngIf="message">{{ message }}</p>

  <div class="ni-add-confirm" *ngIf="pending">
    <p>
      Found: <strong>{{ pending.title }}</strong>
      <span class="ni-type ni-type-{{ pending.type }}">{{ pending.type }}</span>
    </p>
    <p class="ni-add-url">{{ pending.feedUrl }}</p>
    <button (click)="confirm()">Subscribe</button>
    <button (click)="cancel()">Cancel</button>
  </div>

  <p class="ni-msg" *ngIf="subscriptions.length === 0">No feeds yet. Paste a URL above.</p>

  <ul class="ni-feed-list">
    <li *ngFor="let sub of subscriptions">
      <span class="ni-type ni-type-{{ sub.type }}">{{ sub.type }}</span>
      <span class="ni-feed-title">{{ sub.title }}</span>
      <span class="ni-feed-unread" *ngIf="unreadByFeed[sub.feedUrl]">
        {{ unreadByFeed[sub.feedUrl] }} new
      </span>
      <span class="ni-feed-error" *ngIf="errors[sub.feedUrl]" [title]="errors[sub.feedUrl]">
        &#9888; error
      </span>
      <button class="ni-feed-remove" (click)="remove.emit(sub.id)">Remove</button>
    </li>
  </ul>
</div>
